module.exports = __webpack_public_path__ + "img/dubbelzijdig_50x25mm.53f2d037.jpg";